import PropTypes from 'prop-types';
import React from 'react';
import DistrictColumn from './DistrictColumn.js';
import { Svg } from '../common/Svg.js';

const minDistrictsPerRow = 5;
const maxDistrictRows = 4;

export default class StateSubDirectory extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            shouldDisplay: props.isMobile === false
        };
    }

    getDistrictColumns(array) {
        const numPerRow = Math.max(minDistrictsPerRow, Math.ceil(array.length / maxDistrictRows));
        const numToShow = array.length;
        if (numToShow <= minDistrictsPerRow) {
            return [array];
        }

        const resultRows = [];
        let rowIndexStart = 0;
        let rowIndexEnd = numPerRow;
        while (rowIndexEnd <= numToShow) {
            resultRows.push(array.slice(rowIndexStart, rowIndexEnd));
            rowIndexStart += numPerRow;
            rowIndexEnd += numPerRow;
        }
        if (rowIndexEnd > numToShow) {
            resultRows.push(array.slice(rowIndexStart));
        }
        return resultRows;
    }

    onClick(event) {
        event.preventDefault();
        if (this.props.isMobile) {
            const currentShouldDisplay = this.state.shouldDisplay;
            const newState = {
                shouldDisplay: !currentShouldDisplay,
            };

            this.setState(newState);
        }
    }

    shouldDisplay() {
        return this.state.shouldDisplay;
    }

    getHelperIcon() {
        if (!this.props.isMobile) {
            return null;
        }

        if (this.state.shouldDisplay) {
            return <Svg icon="navigateup" additionalClasses="collapsable" aria-label="collapsable" />;
        } else {
            return <Svg icon="navigatedown" additionalClasses="expandable" aria-label="expandable" />;
        }
    }

    render() {
        const districtColumnData = this.getDistrictColumns(this.props.districtData);
        const districtColumnComponents = districtColumnData.map((districtColumn, index) =>
            <DistrictColumn
                districtData={districtColumn}
                isMobile={this.props.isMobile}
                shouldDisplay={this.shouldDisplay.bind(this)}
                key={'district-col-' + index}
            />,
        );
        return (
            <div className="directory-state-section">
                <a id={this.props.stateDisplayName}></a>
                <span onClick={this.onClick.bind(this)}>
                    <h3>{this.props.stateDisplayName} {this.getHelperIcon()}</h3>
                </span>
                <div className="fluid-container">
                    {districtColumnComponents}
                </div>
            </div>
        );
    }
}

StateSubDirectory.propTypes = {
    stateDisplayName: PropTypes.string.isRequired,
    districtData: PropTypes.arrayOf(PropTypes.object).isRequired,
    isMobile: PropTypes.bool.isRequired
};
